import React from "react";
import CardImg from "../assets/cardImg.png";
const ListCard = ({ className }) => {
  return (
    <div
      className={`rounded-md p-3 border md:w-[350px] border-bgprimary flex items-center gap-4 ${className}`}
    >
      <div className="card_clip_img w-[75px]">
        <img src={CardImg} alt="" className="w-full h-full object-cover" />
      </div>
      <div className="w-full">
        <ul className="ml-4">
          <li className="list-disc text-xs font-quicksand font-medium text-dark">
            LisLancashire
          </li>
          <li className="list-disc text-xs font-quicksand font-medium text-dark">
            Cauliflower
          </li>
          <li className="list-disc text-xs font-quicksand font-medium text-dark">
            Cheese say cheese brie cut the cheese boursin everyone love.
          </li>
        </ul>
      </div>
    </div>
  );
};

export default ListCard;
